<template>
  <div class="bubble">
    <div class="bubble-label" v-if="bubbleInfo">{{bubbleInfo.label}}&nbsp;</div>
    <el-tooltip
      v-if="bubbleInfo.tip"
      :placement="placement">
      <div slot="content">{{bubbleInfo.tip}}<br/>{{bubbleInfo.content}}</div>
      <i class="el-icon-info bubble-icon"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Bubble',
  props: {
    placement: {
      type: String,
      default: 'top-start'
    },
    bubbleInfo: {
      type: Object,
      default: function() {
        return {
          label: '',
          tip: '',
          content: ''
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bubble {
  width: 100%;
  position: relative;
  text-align: right;
  font-size: 14px;
  .bubble-label {
    padding: 0;
    height: 16px;
    line-height: 16px;
    display: inline-block;
    vertical-align: middle;
  }
  .bubble-icon {
    vertical-align: middle;
    color: #C0C4CC;
    font-size: 9px;
    &:hover {
      color: rgba(0, 164, 255, .2);
    }
    &:focus {
      outline-width: 0;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/open/panels/application/panels/common/Bubble.vue